import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";

const VehicleMaintenanceForm = (props) => {
  const [loading, setLoading] = useState(false);

  const frmRef = useRef({});

  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const handleVehicleMachinEquipmentChange = (e) => {
    setClassification(e.target.value);
    setVmerId(0);
    frmRef.current.modal_name.value = "";
    frmRef.current.vme_category.value = "";
    //console.log("vehicleData",vehicleData)
    var vlsit = vehicleData.filter(
      (item) => item.vmeClassific == e.target.value
    );
    //console.log("vlsit",vlsit)
    setVehicleFilterData(vlsit);
  };

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [vendorId, setVendorId] = useState(0);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [currencyId, setCurrencyId] = useState(0);
  const [currancys, setCurrancys] = useState();
  const [taxs, setTaxs] = useState([]);
  const [taxAmount, setTaxAmount] = useState(0);
  const [taxId, setTaxId] = useState();

  const [vehicleData, setVehicleData] = useState([]);
  const [vehicleFilterData, setVehicleFilterData] = useState([]);
  const [vmerId, setVmerId] = useState();
  const [classification, setClassification] = useState();
  const [taxPercentage, setTaxPercentage] = useState();

  const currentDate = new Date().toISOString().slice(0, 10);

  useEffect(() => {
    frmRef.current.time_stamp.value = (
      d.getHours() +
      ":" +
      d.getMinutes()
    ).toString();
    //console.log("time_stamp",  frmRef.current.time_stamp.value);
  }, []);

  const { sendRequest: postMaintenanceInvoice } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const data = {
      miDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      timeStamp: frmRef.current.time_stamp.value,
      supervisorEmployeeId: employeeId,
      vendorName: frmRef.current.vendor_name.value,
      vendorId: vendorId,
      vmeClassification: frmRef.current.vme_classification.value,
      vmerId: vmerId,
      vmeModelName: frmRef.current.modal_name.value,
      vmeTypeCategory: frmRef.current.vme_category.value,
      outOfService: frmRef.current.out_0f_service.value,
      lastMaintenanceDate: moment(
        frmRef.current.last_maintenance_date.value
      ).format("DD/MM/YYYY"),
      nextMaintenanceDate: moment(
        frmRef.current.next_maintenance_date.value
      ).format("DD/MM/YYYY"),
      maintenanceDescription: frmRef.current.maintenance_description.value,
      mechanicPersonName: frmRef.current.mechanic_person_name.value,
      mechanicPersonContactNo:
        frmRef.current.mechanic_person_contact_number.value,
      maintenanceCost: frmRef.current.maintenance_cost.value,
      currency: frmRef.current.currency.value,
      discount: frmRef.current.discount.value,
      discountAmt: frmRef.current.discount_amt.value,
      totalAmt: frmRef.current.total_amount.value,
      tax: frmRef.current.tax.value,
      taxAmount: frmRef.current.totalTaxAmount.value,
      totalMaintenanceCost: frmRef.current.total_work_value.value,
      remark: frmRef.current.remark.value,
      status: 1,
      createdBy: "1",
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };
    //console.log(data);
    if (props.update) {
      data["miId"] = props.update.miId;
    }
    postMaintenanceInvoice(
      {
        url: "/api/maintenanceInvoice/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        setLoading(false);
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
        }
      }
    );
  }, [getCurrency]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getTaxs } = useHttp();

  useEffect(() => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          setTaxs(res);
        }
      }
    );
  }, [getTaxs]);

  const { sendRequest: getvehicleMachineEquip } = useHttp();

  useEffect(() => {
    const vvmrUrl = `/api/vehicleMachineEquipRegistratn/?orgId=${localStorage.getItem(
      "orgId"
    )}`;

    getvehicleMachineEquip(
      {
        url: vvmrUrl,
      },
      (res) => {
        if (res) {
          //console.log("getvehicleMachineEquip",res);
          setVehicleData(res);
        }
      }
    );
  }, [getvehicleMachineEquip]);

  const { sendRequest: getLoadVendor } = useHttp();

  const { sendRequest: getVendor } = useHttp();

  const loadVendorData = (id) => {
    //console.log("id",id)

    if (id > 0) {
      var vlist = vendorDetails.filter((item) => item.vendorId == id);
      //console.log("vlist",vlist)
      if (vlist && vlist.length > 0) {
        //console.log("vlist",vlist)
        frmRef.current.vendorCode.value = vlist[0].vendorCode;
      }
    } else frmRef.current.vendorCode.value = "";
  };

  const LoadVehicleData = (id) => {
    setVmerId(id);
    var itemlist = vehicleFilterData.filter((item) => item.vmerId == id);
    if (itemlist && itemlist.length > 0) {
      var selectedItem = itemlist[0];
      frmRef.current.modal_name.value = selectedItem.vmeModelName;
      frmRef.current.vme_category.value = selectedItem.vmeTypeCategory;
    }
  };

  const laodCalculation = (_maintenanceCost, _discount, _taxPercentage) => {
    _maintenanceCost = _maintenanceCost ?? 0;
    _discount = _discount ?? 0;

    var totAmount = _maintenanceCost;
    var disAmount = 0;
    var taxamt = 0;
    if (_discount > 0) {
      disAmount = (totAmount * _discount) / 100;
      totAmount = totAmount - disAmount;
    }

    frmRef.current.total_amount.value = totAmount;

    if (_taxPercentage > 0) {
      taxamt = (totAmount * _taxPercentage) / 100;
      totAmount = totAmount + taxamt;
    }

    frmRef.current.discount_amt.value = disAmount;
    frmRef.current.totalTaxAmount.value = taxamt;

    frmRef.current.total_work_value.value = totAmount;
  };

  useEffect(() => {
    getVendor(
      {
        url: `/api/vendorList/?orgId=${localStorage.getItem("orgId")}`, //&&warehouseId=${localStorage.getItem("warehouseId")}
      },
      (res) => {
        if (res) {
          //console.log("getVendor",res)
          setVendorDetails(res);
        }
      }
    );
  }, [getVendor]);

  useEffect(() => {
    if (props.update) {
      //console.log("props.update",props.update)
      frmRef.current.date.value = moment(props.update.vmerDate).format(
        "YYYY-MM-DD"
      );
      frmRef.current.emp_id.value = props.update.SupervisorEmployeeId;
      frmRef.current.time_stamp.value = moment(
        props.update.timeStamp,
        "HH:mm"
      ).format("hh:mm");
      frmRef.current.remark.value = props.update.remark;

      frmRef.current.vendor_name.value = props.update.vendorName;
      setVendorId(props.update.vendorId);
      frmRef.current.vme_classification.value = props.update.vmeClassification;
      frmRef.current.modal_name.value = props.update.vmeModelName;
      frmRef.current.vme_category.value = props.update.vmeType;

      frmRef.current.vendorCode.value = props.update.vendorCode;
      setEmployeeId(props.update.supervisorEmployeeId);
      frmRef.current.out_0f_service.value = props.update.outOfService;
      frmRef.current.last_maintenance_date.value = moment(
        props.update.last_maintenance_date
      ).format("YYYY-MM-DD");
      frmRef.current.next_maintenance_date.value = moment(
        props.update.last_maintenance_date
      ).format("YYYY-MM-DD");

      //console.log("vmeClassification",props.update.vmeClassification)
      LoadVehicleData(props.update.vmeClassification);
      frmRef.current.maintenance_description.value =
        props.update.maintenanceDescription;
      frmRef.current.mechanic_person_name.value =
        props.update.mechanicPersonName;
      frmRef.current.mechanic_person_contact_number.value =
        props.update.mechanicPersonContactNo;
      frmRef.current.maintenance_cost.value = props.update.maintenanceCost;
      frmRef.current.currency.value = props.update.currency;
      frmRef.current.discount.value = props.update.discount;
      frmRef.current.discount_amt.value = props.update.discountAmt;
      frmRef.current.total_amount.value = props.update.totalAmt;
      frmRef.current.tax.value = props.update.tax;
      frmRef.current.total_work_value.value = props.update.totalMaintenanceCost;
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">
                    Add Vehicle Maintenance Invoice
                  </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}>{"Date "}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"time_stamp"}>{"TimeStamp"}</label>
                      <input
                        type={"time"}
                        id={"time_stamp"}
                        required
                        ref={(el) => (frmRef.current["time_stamp"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"emp_id"}>{"Assigned Employee"}</label>
                      <select
                        id="emp_id"
                        className="form-control"
                        ref={(el) => (frmRef.current["emp_id"] = el)}
                        value={employeeId}
                        required
                        onChange={(e) => {
                          var empid = 0;
                          if (e.target.value != "") {
                            empid = e.target.value;
                          }

                          setEmployeeId(empid);
                        }}
                      >
                        <option value="">select</option>
                        {employeeData &&
                          employeeData.map((x) => (
                            <option key={x.empId} value={x.empId}>
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"vendor_name"}>{"Vendor Name"}</label>
                      <select
                        id="vendor_name"
                        className="form-control"
                        value={vendorId}
                        ref={(el) => (frmRef.current["vendor_name"] = el)}
                        required
                        onChange={(e) => {
                          var vId = 0;
                          if (e.target.value != "") {
                            vId = e.target.value;
                          }

                          setVendorId(vId);

                          loadVendorData(vId);
                        }}
                      >
                        <option value="">select</option>
                        {vendorDetails &&
                          vendorDetails.map((x) => (
                            <option
                              key={x.vendorId}
                              value={x.vendorId}
                              vendor-id={x.vendorId}
                            >
                              {x.vendorName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"vendor_id"}>{"Vendor Code"}</label>
                      <input
                        type={"text"}
                        id={"vendorCode"}
                        disabled
                        ref={(el) => (frmRef.current["vendorCode"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"vme_classification"}>
                        {"Vehicle/Machine/Equipment Classification"}
                      </label>
                      <select
                        id="vme_classification"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["vme_classification"] = el)
                        }
                        onChange={handleVehicleMachinEquipmentChange}
                        required
                      >
                        <option value="">select</option>
                        <option value="Vehicle">Vehicle</option>
                        <option value="Machine">Machine</option>
                        <option value="Equipment">Equipment</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"vme_id"}>
                        {"Vehicle/Machine/Equipment id"}
                      </label>
                      <select
                        id="vmerId"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["vmerId"] = el)}
                        value={vmerId}
                        onChange={(e) => {
                          setVmerId(e.target.value);
                          LoadVehicleData(e.target.value);
                        }}
                      >
                        <option value="">select</option>
                        {vehicleFilterData &&
                          vehicleFilterData.map((x) => (
                            <option
                              key={x.vmerId}
                              vmer-id={x.vmerId}
                              value={x.vmerId}
                            >
                              {x.vmeNo}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"labour_transport_cost"}>
                        {"Vehicle/Machine/Equipment Model Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"modal_name"}
                        required
                        ref={(el) => (frmRef.current["modal_name"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"vme_category"}>
                        {"Vehicle/Machine/Equipment Type/Category"}
                      </label>

                      <input
                        type={"text"}
                        id={"vme_category"}
                        required
                        ref={(el) => (frmRef.current["vme_category"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"out_0f_service"}>
                        {"Out Of service"}
                      </label>
                      <select
                        id="out_0f_service"
                        className="form-control"
                        ref={(el) => (frmRef.current["out_0f_service"] = el)}
                        required
                      >
                        <option value="">select</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"last_maintenance_date"}>
                        {"Last Maintenance Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"last_maintenance_date"}
                        required
                        ref={(el) =>
                          (frmRef.current["last_maintenance_date"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"next_maintenance_date"}>
                        {"Next Maintenance Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"next_maintenance_date"}
                        required
                        ref={(el) =>
                          (frmRef.current["next_maintenance_date"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"maintenance_description"}>
                        {"Maintenance Description"}
                      </label>
                      <input
                        type={"text"}
                        id={"maintenance_description"}
                        required
                        ref={(el) =>
                          (frmRef.current["maintenance_description"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"mechanic_person_name"}>
                        {"Mechanic Person Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"mechanic_person_name"}
                        required
                        ref={(el) =>
                          (frmRef.current["mechanic_person_name"] = el)
                        }
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"mechanic_person_contact_number"}>
                        {"Mechanic Person Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"mechanic_person_contact_number"}
                        required
                        ref={(el) =>
                          (frmRef.current["mechanic_person_contact_number"] =
                            el)
                        }
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"maintenance_cost"}>
                        {"Maintenance Cost"}
                      </label>
                      <input
                        type={"text"}
                        id={"maintenance_cost"}
                        required
                        ref={(el) => (frmRef.current["maintenance_cost"] = el)}
                        className="form-control"
                        onChange={(e) => {
                          var mCost = 0;
                          if (e.target.value != "") {
                            mCost = e.target.value;
                          }

                          var discount1 = frmRef.current.discount.value ?? 0;
                          laodCalculation(mCost, discount1, taxPercentage);
                        }}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"currency"}> {"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        required
                      >
                        <option selected disabled value="">
                          Select
                        </option>
                        {currancys &&
                          currancys.map((x) => (
                            <option
                              key={x.currencyId}
                              value={x.currencyId}
                              onChange={(e) => {
                                var cId = 0;
                                if (e.target.value != "") {
                                  cId = e.target.value;
                                }

                                setCurrencyId(cId);
                              }}
                            >
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"discount"}>{"Discount(%)"}</label>
                      <input
                        type={"text"}
                        id={"discount"}
                        required
                        ref={(el) => (frmRef.current["discount"] = el)}
                        className="form-control"
                        onChange={(e) => {
                          var mdiscount = 0;
                          if (e.target.value != "") {
                            mdiscount = e.target.value;
                          }

                          var mCost =
                            frmRef.current.maintenance_cost.value ?? 0;
                          laodCalculation(mCost, mdiscount, taxPercentage);
                        }}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"discount_amt"}>
                        {"Discount Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"discount_amt"}
                        required
                        ref={(el) => (frmRef.current["discount_amt"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"total_amount"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amount"}
                        required
                        ref={(el) => (frmRef.current["total_amount"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        // onChange={handleTaxChange}
                        required
                        onChange={(e) => {
                          var mtaxPercentage = 0;
                          if (e.target.value != "") {
                            var taxId = e.target.value;
                            var tlist = taxs.filter(
                              (item) => item.taxId == taxId
                            );

                            mtaxPercentage = tlist && tlist[0].taxPercentage;
                            setTaxPercentage(mtaxPercentage);
                          }

                          var mCost =
                            frmRef.current.maintenance_cost.value ?? 0;

                          var discount1 = frmRef.current.discount.value ?? 0;
                          laodCalculation(mCost, discount1, mtaxPercentage);
                        }}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option
                              key={x.taxId}
                              value={x.taxId}
                              selected={
                                props.update && x.taxId === props.update.taxId
                              }
                            >
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"TotalTaxAmount"}>
                        {"Total Tax Amount"}
                      </label>
                      <input
                        type={"text"}
                        id={"totalTaxAmount"}
                        required
                        ref={(el) => (frmRef.current["totalTaxAmount"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"total_work_value"}>
                        {"Total Maintenance value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_work_value"}
                        required
                        ref={(el) => (frmRef.current["total_work_value"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}&nbsp;
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default VehicleMaintenanceForm;
